// @flow @format
import {put, select, take} from 'redux-saga/effects';
import {PrivateApi} from 'lib/cloner-api';
import {addUsers, requestUsers, FETCH_USERS} from '../reducers/entities/users';

import type {User} from 'lib/cloner-api';
import type {State} from '../reducers';
import type {FetchUsersAction} from '../reducers/entities/users';

function makeSaga(api: PrivateApi) {
	return function*(): Generator<*, void, *> {
		while (true) {
			const action: FetchUsersAction = yield take(FETCH_USERS);
			const state: State = yield select();
			const users = state.entities.users;

			if (
				users.byGroup[action.groupId] ||
				users.entitiesFetching[action.groupId]
			) {
				continue;
			}

			yield put(requestUsers(action.groupId));

			try {
				const users: User[] = yield api.getUsersByGroup(action.groupId);
				yield put(addUsers(action.groupId, users || []));
			} catch (error) {
				console.error(error);
			}
		}
	};
}

export default makeSaga;



// WEBPACK FOOTER //
// ./src/sagas/users.js